import { PageTitle } from "@common-metronic/layout/core"
import { Navigate, Route, Routes } from "react-router-dom"
import GestionStructureDeclarationsVoyants from "../structure/declarations/voyants/GestionStructureDeclarationsVoyants"
import ConsultantsDeclarationsListing from "../../business/consultants/declaration/listing/ConsultantsDeclarationsListing"
import GestionProductionDeclarationsVoyants from "../production/GestionProductionDeclarationsVoyants"
import {
     ROUTING_BREADCRUMBS_GESTION_ASSURANCES_LISTING,
     ROUTING_BREADCRUMBS_GESTION_PRODUCTION,
     ROUTING_BREADCRUMBS_GESTION_PRODUCTION_DECLARATIONS_VOYANTS,
     ROUTING_BREADCRUMBS_GESTION_STRUCTURE,
     ROUTING_BREADCRUMBS_GESTION_STRUCTURE_DECLARATIONS_VOYANTS,
     ROUTING_BREADCRUMBS_GESTION_STRUCTURE_STAFF,
} from "./routing-breadcrumbs"
import {
     ROUTING_RELATIVE_PATH_GESTION_ASSURANCES,
     ROUTING_RELATIVE_PATH_GESTION_PRODUCTION,
     ROUTING_RELATIVE_PATH_GESTION_PRODUCTION_DDC_LISTING,
     ROUTING_RELATIVE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING,
     ROUTING_RELATIVE_PATH_GESTION_PRODUCTION_DECLARATIONS_VOYANTS,
     ROUTING_RELATIVE_PATH_GESTION_PRODUCTION_MALADIES_LISTING,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_DDC_LISTING,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_DECLARATIONS_LISTING,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_DECLARATIONS_VOYANTS,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_MALADIES_LISTING,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_ORGANIGRAMME,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_CREATE,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DEMANDE_EMBAUCHE_FINALISER,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DEMANDE_EMBAUCHE_DETAILS,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DEMANDE_EMBAUCHE_EDITER,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DEMANDE_EMBAUCHE_DOCUMENTS_EMBAUCHE,
     ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DETAILS,
     ROUTING_RELATIVE_PATH_GESTION_BASE_DOCUMENTAIRE_DOCUMENTS_EMBAUCHE,
} from "./routing-endpoints"
import GestionStructureDeclarationsListing from "../structure/declarations/listing/GestionStructureDeclarationsListing"
import ConsultantDdcListing from "../../business/consultants/ddc/listing/ConsultantDdcListing"
import PersonnelDdcListingMultiplePersonnel from "../../personnel/declaration/ddc/listing-multiple-personnel/PersonnelDdcListingMultiplePersonnel"
import PersonnelMaladieListingMultiple from "../../personnel/declaration/maladie/listing/listing-multiple/PersonnelMaladieListingMultiple"
import ConsultantsMaladiesListingMultiple from "../../business/consultants/maladie/listing-multiple/ConsultantsMaladiesListingMultiple"
import PersonnelListing from "../../personnel/listing/PersonnelListing"
import PersonnelDetails from "../../personnel/details/PersonnelDetails"
import { PersonnelsOrganigramme } from "../../personnel/details/organigramme/PersonnelsOrganigramme"
import { PersonnelCreate } from "../../personnel/create"
import DemandesEmbaucheStaffListing from "../../personnel/demandeEmbauche/DemandesEmbaucheStaffListing"
import FinaliserDemandeEmbauche from "../../personnel/demandeEmbauche/FinaliserDemandeEmbauche"
import DemandeEmbaucheStaffDetails from "../../personnel/demandeEmbauche/DemandeEmbaucheStaffDetails"
import EnvoyerDocumentsEmbauche from "../../personnel/demandeEmbauche/EnvoyerDocumentsEmbauche"
import DocumentsEmbaucheAdmin from "../../personnel/documentsEmbaucheAdmin/DocumentsEmbaucheAdmin"
import AssurancesListing from "../assurance/listing/AssurancesListing"

const GestionRouting = () => {
     const urlParams = new URLSearchParams(window.location.search)

     return (
          <Routes>
               {/* ASSURANCE */}
               <Route path={ROUTING_RELATIVE_PATH_GESTION_ASSURANCES}>
                    <Route
                         path={"listing"}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_ASSURANCES_LISTING} />
                                   <AssurancesListing />
                              </>
                         }
                    />
               </Route>

               {/* PRODUCTION */}
               <Route path={ROUTING_RELATIVE_PATH_GESTION_PRODUCTION}>
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_PRODUCTION_DECLARATIONS_VOYANTS}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_PRODUCTION}>Déclarations ( voyants )</PageTitle>
                                   <GestionProductionDeclarationsVoyants />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_PRODUCTION_DECLARATIONS_LISTING}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_PRODUCTION_DECLARATIONS_VOYANTS}>Liste</PageTitle>
                                   <ConsultantsDeclarationsListing />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_PRODUCTION_DDC_LISTING}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_PRODUCTION}>DDC</PageTitle>
                                   <ConsultantDdcListing title={"Liste des DDC"} isFilterIconVisible={true} />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_PRODUCTION_MALADIES_LISTING}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_PRODUCTION}>Arrêts maladie</PageTitle>
                                   <ConsultantsMaladiesListingMultiple title={"Liste des arrêts maladie"} isFilterIconVisible={true} />
                              </>
                         }
                    />
               </Route>

               {/* STRUCTURE */}
               <Route path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE}>
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_DECLARATIONS_VOYANTS}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE}>Déclarations ( voyants )</PageTitle>
                                   <GestionStructureDeclarationsVoyants />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE}>Staff</PageTitle>
                                   <PersonnelListing />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_ORGANIGRAMME}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE_STAFF}>Organigramme fonctionnel</PageTitle>
                                   <PersonnelsOrganigramme />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DETAILS}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE_STAFF}>{urlParams.get("nom")}</PageTitle>
                                   <PersonnelDetails />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_CREATE}
                         element={
                              <>
                                   <PersonnelCreate />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE_STAFF}>Demandes d'embauche</PageTitle>
                                   <DemandesEmbaucheStaffListing />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DEMANDE_EMBAUCHE_FINALISER}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE_STAFF}>Finalisation</PageTitle>
                                   <FinaliserDemandeEmbauche />
                              </>
                         }
                    />
                    <Route path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DEMANDE_EMBAUCHE_DETAILS} element={<DemandeEmbaucheStaffDetails />} />
                    <Route path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DEMANDE_EMBAUCHE_DOCUMENTS_EMBAUCHE} element={<EnvoyerDocumentsEmbauche />} />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_STAFF_DEMANDE_EMBAUCHE_EDITER}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE_STAFF}>Modifier la demande</PageTitle>
                                   <PersonnelCreate />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_DECLARATIONS_LISTING}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE_DECLARATIONS_VOYANTS}>Liste</PageTitle>
                                   <GestionStructureDeclarationsListing />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_DDC_LISTING}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE}>DDC</PageTitle>
                                   <PersonnelDdcListingMultiplePersonnel title={"Liste des DDC"} isSearchBarVisible={true} />
                              </>
                         }
                    />
                    <Route
                         path={ROUTING_RELATIVE_PATH_GESTION_STRUCTURE_MALADIES_LISTING}
                         element={
                              <>
                                   <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE}>Arrêts maladie</PageTitle>
                                   <PersonnelMaladieListingMultiple title={"Liste des arrêts maladie"} isFilterIconVisible={true} />
                              </>
                         }
                    />
               </Route>

               {/* Base documentaire */}
               <Route
                    path={ROUTING_RELATIVE_PATH_GESTION_BASE_DOCUMENTAIRE_DOCUMENTS_EMBAUCHE}
                    element={<DocumentsEmbaucheAdmin />}
               />

               <Route index element={<Navigate to="profil" />} />
          </Routes>
     )
}

export default GestionRouting
